import React, { useState } from "react";
import { StaticImage } from "gatsby-plugin-image";
import { useInView } from "react-intersection-observer";

// components
import VideoModal from "../../Home/TwinCanHelp/VideoModal";

// images
import playIcon from "../../../images/icons/play_icon.png";

// styles
import * as styles from "./AiTwinWork.module.css";

const AiTwinWorkComponent = ({
  ctaText,
  onCtaClick = () => {},
  sessionId,
  updateSessionId,
  videoName,
  videoLink,
  videoPageName,
}) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const [showVideoModal, setShowVideoModal] = useState(false);

  const openVideo = () => {
    setShowVideoModal(true);
    if (onCtaClick) {
      onCtaClick(ctaText);
    }
  };

  const closeVideo = () => {
    setShowVideoModal(false);
  };

  return (
    <>
      <section className={styles.aiTwinWorkWrapper}>
        <div
          ref={ref}
          className={`container scroll_animate ${inView && "inview"}`}
        >
          <div className={styles.aiTwinWorkContent}>
            <div className={styles.headerSection}>
              <h1 className={styles.mainTitle}>How AI Digital Twin Works</h1>
              <p className={styles.description}>
                The Digital Twin shows you metabolic monitoring in realtime
                using data from smart devices to help you make informed choices
                in your daily life.
              </p>
            </div>

            <div className={styles.videoSection}>
              <div className={styles.videoWrapper}>
                <div className={styles.videoImageContainer}>
                  <StaticImage
                    src="../../../images/aboutProgram/aiDigitalTwin.png"
                    alt="How AI Digital Twin Works"
                    placeholder="blurred"
                    quality={90}
                    className={styles.videoImage}
                    loading="lazy"
                  />
                  <div className={styles.videoOverlay}>
                    <div className={styles.overlayContent}>
                      <h2 className={styles.overlayTitle}>
                        See how Twin Works
                      </h2>
                      <button
                        className={styles.playButton}
                        onClick={openVideo}
                        aria-label="Play Video"
                      >
                        <span className={styles.playButtonText}>{ctaText}</span>
                        <img
                          src={playIcon}
                          alt="Play"
                          className={styles.playIcon}
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Video Modal */}
      <VideoModal
        show={showVideoModal}
        onHide={closeVideo}
        videoLink={videoLink}
        videoName={videoName}
        sessionId={sessionId}
        updateSessionId={updateSessionId}
        videoPageName={videoPageName}
      />
    </>
  );
};

export default AiTwinWorkComponent;
